<script lang="ts">
import { defineComponent, h } from 'vue'
import { useNamespace } from '@zoryn/hooks'

import type { Component, PropType, VNode } from 'vue'

function isHeaderOrFooter(vNode: VNode) {
  const type = vNode.type as Component & { __name?: string }
  const name = type?.name || type?.__name
  return name === 'ZHeader' || name === 'ZFooter'
}

export default defineComponent({
  name: 'ZContainer',
  props: {
    /**
     * @description layout direction for child elements
     */
    direction: {
      type: String as PropType<'horizontal' | 'vertical'>,
      default: undefined,
    },
  },
  setup(props, { slots }) {
    const ns = useNamespace('container')

    // Inspect slot children in the same render pass as `<slot />`.
    // Calling `slots.default()` inside a computed re-creates nested
    // poppers/dropdowns and can hit "Maximum recursive updates exceeded".
    return () => {
      const children = slots.default?.() ?? []
      const vertical =
        props.direction === 'vertical'
          ? true
          : props.direction === 'horizontal'
            ? false
            : children.some(isHeaderOrFooter)

      return h(
        'section',
        { class: [ns.b(), ns.is('vertical', vertical)] },
        children
      )
    }
  },
})
</script>
